import Vue from 'vue';
import SubjectService from '@/services/subject';

import { FETCH_ALL, SAVE } from '../actions.types';
import {
  SET_ERROR,
  SET_ITEM,
  SET_ITEMS,
  SET_FILTERS,
  REMOVE_FILTER,
  REMOVE_FILTERS
} from '../mutations.types';

const initialState = () => {
  return {
    error: null,
    items: [],
    pagination: {},
    filters: {
      page: { value: 1 },
      sort: { value: 'street' },
      reverse: { value: false }
    }
  };
};

export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async [FETCH_ALL]({ commit, state }) {
      try {
        const response = await SubjectService.query(state.filters);
        commit(SET_ITEMS, response.data);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    },
    async [SAVE]({ commit }, subject) {
      try {
        await SubjectService.save(subject.id, subject);
        commit(SET_ITEM, subject);
      } catch (error) {
        commit(SET_ERROR, error.data);
      }
    }
  },
  mutations: {
    [SET_ERROR](state, error) {
      state.error = error;
    },
    [SET_ITEM](state, subject) {
      const index = state.items.findIndex(item => item.id === subject.id);
      Vue.set(state.items, index, subject);
    },
    [SET_ITEMS](state, response) {
      state.error = null;
      state.items = response.data;
      Vue.set(state, 'pagination', response.meta);
    },
    [SET_FILTERS](state, filter) {
      if (filter.value == null) {
        Vue.set(state.filters, 'page', 1);
        Vue.delete(state.filters, filter.key);
      } else {
        Vue.set(state.filters, filter.key, {
          value: filter.value,
          label: filter.label
        });
      }
    },
    [REMOVE_FILTER](state, filter) {
      Vue.delete(state.filters, filter);
    },
    [REMOVE_FILTERS](state) {
      Object.assign(state, initialState());
    }
  }
};
